import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=b30ed8a2"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports